import Vue from 'vue'
import axios from 'axios'
import Store from '@/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  showSpinner: false
});
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '' : '/api2'
// axios.defaults.validateStatus = status=> {
//   return status >= 200
// }
// axios.defaults.timeout = 1000;
axios.interceptors.request.use(item => {  //拦截请求
  NProgress.start()
  item.headers.token = Store.getters.token
  return item
}, error => {
  Message.error('请检查网络连接！')
  return Promise.reject(error)
})

axios.interceptors.response.use(item => {  //拦截响应
  NProgress.done();
  return item
}, error => {
  if (error.response.status==401){
    Store.commit('set_token', '')
    Store.dispatch('getToken');
  }if (error.response.status==500){
    const msg = error.response.data;
    NProgress.done();
    Message.error(msg);
  }else{
    const msg = error.response.data.msg || '网络错误！';
    NProgress.done();
    Message.error(msg);
  }
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

export default axios